import React, { Component } from 'react';
import { bindActionCreators } from 'redux';
import { connect } from 'react-redux';
import { reduxForm, Field, formValueSelector } from 'redux-form';
import DateFormat from '../common/dateFormat/DateFormat';

import ContentHeader from '../common/template/contentHeader';
import Content from '../common/template/content';
import ContentCard from '../common/template/contentCard';
import Row from '../common/layout/row';
import Grid from '../common/layout/grid';
import Table from '../common/table/table';
import THead from '../common/table/tHead';
import Tr from '../common/table/tr';
import Th from '../common/table/th';
import TBody from '../common/table/tBody';
import Td from '../common/table/td';
import ButtonTable from '../common/table/buttonTable';
import BoxButtonHeader from '../common/button/boxButtonHeader';
import Button from '../common/button/button';
import Form from './combustivelSaidaForm';
import LabelAndInputMask from '../common/form/labelAndInputMask';
import Select from '../common/form/select';

import { setModoTela, initForm, salvar, excluir, getLista, getListaUsuario, getListaEquipamento, getListaTanque, getListaBomba, getListaCombustivel, getListaFornecedor, setFiltro } from './combustivelSaidaActions';

class CombustivelSaida extends Component {

    componentWillMount() {
		this.props.getLista(this.props.sessao.id_empresa);
		this.props.getListaUsuario(this.props.sessao.id_empresa);
		this.props.getListaEquipamento(this.props.sessao.id_empresa);
		this.props.getListaTanque(this.props.sessao.id_empresa);
		this.props.getListaBomba(this.props.sessao.id_empresa);
		this.props.getListaCombustivel(this.props.sessao.id_empresa);
		this.props.getListaFornecedor(this.props.sessao.id_empresa);
    }

    render() {
        return (
            <div>
                <ContentHeader title='Abastecimento' small='Cadastro' />
                <Content>
					{this.props.modoTela == 'cadastro' ? (
						<Form onSubmit={this.props.salvar} />
					) : null}
					{this.props.modoTela == 'exclusao' ? (
						<Form excluir onSubmit={this.props.excluir} />
					) : null}
					{this.props.modoTela == 'lista' ? this.lista() : null}
                </Content>
            </div>
        )
    }

	lista() {
		return (
			<ContentCard>
				<BoxButtonHeader>
					<Button
						text='Adicionar'
						type={'success'}
						icon={'fa fa-plus'}
						style={{ position: 'fixed' }}
						event={() => {
							this.props.setModoTela('cadastro', {});
							this.props.initForm();
						}} />
				</BoxButtonHeader>
				<Row>
					<LabelAndInputMask
						label='Data Inicial'
						placeholder='Informe a Data Inicial'
						mask={'99/99/9999'}
						cols='12 4 3'
						value={this.props.filtro.dataInicial}
						onChange={data => {
							this.props.setFiltro({
								...this.props.filtro,
								dataInicial: data.target.value
							});
							this.props.getLista(this.props.sessao.id_empresa);
						}} />
					<LabelAndInputMask
						label='Data Final'
						placeholder='Informe a Data Final'
						mask={'99/99/9999'}
						cols='12 4 3'
						value={this.props.filtro.dataFinal}
						onChange={data => {
							this.props.setFiltro({
								...this.props.filtro,
								dataFinal: data.target.value
							});
							this.props.getLista(this.props.sessao.id_empresa);
						}} />

					<Select
						name='id_equipamento'
						options={this.props.listaEquipamento.filter(equipamento => !equipamento.reboque)}
						label='Equipamento *'
						cols='12 4 3'
						placeholder='Selecione o Equipamento'
						value={this.props.filtro.id_equipamento}
						onChange={value => {
							this.props.setFiltro({
								...this.props.filtro,
								id_equipamento: value
							});
							this.props.getLista(this.props.sessao.id_empresa);
						}} />

					<Select
						name='id_usuario'
						options={this.props.listaUsuario}
						label='Usuário *'
						cols='12 4 3'
						placeholder='Selecione o Usuário'
						value={this.props.filtro.id_usuario}
						onChange={value => {
							this.props.setFiltro({
								...this.props.filtro,
								id_usuario: value
							});
							this.props.getLista(this.props.sessao.id_empresa);
						}} />
				</Row>

				<Table>
					<THead>
						<Tr>
							<Th>Data e Hora</Th>
							<Th>Tanque/Fornecedor</Th>
							<Th>Bomba</Th>
							<Th>Combustível</Th>
							<Th>Equipamento</Th>
							<Th alignRight>Quantidade</Th>
							<Th alignCenter>Completou</Th>
							<Th Left>Odômetro/Horímetro</Th>
							<Th Left>Média Km/Hr</Th>
							<Th>Responsável</Th>
							<Th>Operador</Th>
							<Th alignCenter acoes>Ações</Th>
						</Tr>
					</THead>
					<TBody>
						{(this.props.lista).map(item => (
							<Tr key={item.id}>
								<Td>{DateFormat.formatarDataHoraSqlParaTela(item.datahora_saida)}</Td>
								<Td>{item.identificacao_tanque || item.nome_fornecedor}</Td>
								<Td>{item.identificacao_bomba}</Td>
								<Td>{item.nome_combustivel}</Td>
								<Td>{item.nome_equipamento}</Td>
								<Td alignRight>{parseFloat(item.quantidade || 0).toFixed(item.casas_decimais_bomba).replace('.', ',')}</Td>
								<Td alignCenter>{item.completou ? 'Sim' : 'Não'}</Td>
								<Td alignLeft>{parseFloat(item.hodometro || 0).toFixed(2).replace('.', ',')} Km - {parseFloat(item.horimetro || 0).toFixed(2).replace('.', ',')} Hr</Td>
								<Td alignLeft>{parseFloat(item.media_hodometro || 0).toFixed(2).replace('.', ',')} km/L - {parseFloat(item.media_horimetro || 0).toFixed(2).replace('.', ',')} L/Hr</Td>
								<Td>{item.nome_responsavel}</Td>
								<Td>{item.nome_operador}</Td>
								<Td alignCenter>
									<ButtonTable
										type={'warning'}
										icon={'fa fa-pencil'}
										event={() => {
											this.props.setModoTela('cadastro', item);
											this.props.initForm({
												...item,
												acumulador_bomba_inicial: item.acumulador_bomba_inicial.replace('.', ','),
												acumulador_bomba_final: item.acumulador_bomba_final.replace('.', ','),
												quantidade: item.quantidade.replace('.', ','),
												valor: item.valor.replace('.', ','),
												hodometro: item.hodometro.replace('.', ','),
												horimetro: item.horimetro.replace('.', ',')
											});
										}} />
									<ButtonTable
										type={'danger'}
										icon={'fa fa-trash-o'}
										event={() => {
											this.props.setModoTela('exclusao', item);
											this.props.initForm({
												...item,
												acumulador_bomba_inicial: item.acumulador_bomba_inicial.replace('.', ','),
												acumulador_bomba_final: item.acumulador_bomba_final.replace('.', ','),
												quantidade: item.quantidade.replace('.', ','),
												valor: item.valor.replace('.', ','),
												hodometro: item.hodometro.replace('.', ','),
												horimetro: item.horimetro.replace('.', ',')
											});
										}} />
								</Td>
							</Tr>
						))}
					</TBody>
				</Table>
			</ContentCard>
		);
	}


}

const mapStateToProps = state => ({
	sessao: state.auth.usuario,
	modoTela: state.combustivelSaida.modoTela,
	lista: state.combustivelSaida.lista,
	filtro: state.combustivelSaida.filtro,
	listaUsuario: state.combustivelSaida.listaUsuario,
	listaEquipamento: state.combustivelSaida.listaEquipamento,
});
const mapDispatchToProps = dispatch => bindActionCreators({ setModoTela, initForm, salvar, excluir, getLista, getListaUsuario, getListaEquipamento, getListaTanque, getListaBomba, getListaCombustivel, getListaFornecedor, setFiltro }, dispatch);
export default connect(mapStateToProps, mapDispatchToProps)(CombustivelSaida);
